/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_No_Presets_TextInputs */

const en_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No presets saved`)
};

const fr_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun preset enregistre`)
};

const de_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Voreinstellungen gespeichert`)
};

const it_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset salvato`)
};

const ru_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предустановки не сохранены`)
};

const es_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ajustes preestablecidos guardados`)
};

const zh_cn2_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未保存任何预设。`)
};

const ja_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが保存されていません`)
};

const hi_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्रीसेट सहेजा नहीं गया`)
};

const pt_pt2_preset_manager_no_presets_text = /** @type {(inputs: Preset_Manager_No_Presets_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição salva`)
};

/**
* | output |
* | --- |
* | "No presets saved" |
*
* @param {Preset_Manager_No_Presets_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_no_presets_text = /** @type {((inputs?: Preset_Manager_No_Presets_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_No_Presets_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_no_presets_text(inputs)
	if (locale === "de") return de_preset_manager_no_presets_text(inputs)
	if (locale === "it") return it_preset_manager_no_presets_text(inputs)
	if (locale === "ru") return ru_preset_manager_no_presets_text(inputs)
	if (locale === "es") return es_preset_manager_no_presets_text(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_no_presets_text(inputs)
	if (locale === "ja") return ja_preset_manager_no_presets_text(inputs)
	if (locale === "hi") return hi_preset_manager_no_presets_text(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_no_presets_text(inputs)
	return en_preset_manager_no_presets_text(inputs)
});